'use strict';

require('slick-carousel');

const $ = require('jquery');

/**
 * Slick init with scope.
 * @param $scope
 * @constructor
 */
class SlickInit {
    /**
	 * Construct the object.
	 * @param $scope
	 */
    constructor($scope = $('body')) {
        const _ = this;

        this.slickConfigs = {
            default: {
                slidesToShow: 1,
                slidesToScroll: 1,
                autoplay: false,
                dots: false,
                arrows: true,
                infinite: false,
            },
            headerBig: {
                slidesToShow: 1,
                slidesToScroll: 1,
                autoplay: false,
                dots: false,
                arrows: true,
                infinite: true,
            },
            headerTiny: {
                slidesToShow: 1,
                slidesToScroll: 1,
                autoplay: false,
                dots: true,
                arrows: false,
                infinite: false,
            },
        };
        this._$scope = $scope;
        this._slicks = this._getSlicks();

        if (this._slicks.length) {
            this._slicks.each(function() {
                _.initSlider($(this), $(this).attr('data-slider-config'));
            });
        }
    }

    /**
	 * Get all slider elements.
	 * @returns {*}
	 * @private
	 */
    _getSlicks() {
        return this._$scope.find('[data-slider-config]');
    }

    /**
	 * Init single slide with specified config.
	 * @param $el
	 * @param strConfig
	 */
    initSlider($el, strConfig = 'default') {
        let arrCurrConfig = this.slickConfigs[strConfig];

        if (arrCurrConfig && !$el.hasClass('slick-slider')) {
            $el.slick(arrCurrConfig);
        } else {
            console.log('no config found or slick already initialized!');
        }
    }
}

export default SlickInit;
